// Module
var code = "<div class=\"basket-engraving-input\"> <input class=\"basket-engraving-input__input\" type=\"text\" value=\"{{message}}\" placeholder=\"[[EngravingInputPlaceholder]]\"/> <div class=\"basket-engraving-input__validation\"></div> </div>";
// Exports
module.exports = code;